<template>
  <div class="goods-control">
    <div class="add-goods-content" v-if="value.length">
      <draggable :list="value" animation="100">
        <div
          v-for="(item, i) of value"
          :key="item.id"
          :class="{ 'mr-0': (i + 1) % 4 === 0 }"
        >
          <div
            v-for="(it, j) of item.productList"
            :key="it.id"
            :style="{
              marginRight: j + 1 === item.productList.length ? '0' : '4px'
            }"
          >
            <img :src="it.imageUrl" alt="" />
          </div>
          <i class="el-icon-error" @click="removeGoodItem(i)"></i>
        </div>
      </draggable>
    </div>
    <el-button icon="el-icon-plus" @click="addSortGoods"
      >选择搭销商品（{{ value.length }}/{{ maxGoodsCount }}）</el-button
    >

    <SelectAssemblyProductDialog
      :isShowDialog="isShowAssemblyDialog"
      :SelectedProductList="selectedGoods"
      @selectProductList="selectProductList"
      @closeShowDialog="isShowAssemblyDialog = false"
      :canMultipleChoice="true"
    />
  </div>
</template>

<script>
import draggable from "vuedraggable";
import SelectAssemblyProductDialog from "../../../../components/SelectAssemblyProductDialog";
export default {
  components: {
    draggable,
    SelectAssemblyProductDialog
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    maxGoodsCount: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      selectedGoods: [],
      isShowAssemblyDialog: false
    };
  },
  methods: {
    addSortGoods() {
      this.selectedGoods = this.value;
      this.isShowAssemblyDialog = true;
    },
    selectProductList(params) {
      this.$emit("input", params);
    },
    removeGoodItem(i) {
      this.value.splice(i, 1);
    }
  }
};
</script>

<style lang="less" scoped>
.goods-control {
  .add-goods-content {
    width: 338px;
    background: #f7f8fa;
    border-radius: 4px;
    padding: 14px 10px 0;
    height: 250px;
    overflow-y: scroll;
    > div {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      > div {
        height: 78px;
        position: relative;
        margin-bottom: 9px;
        cursor: move;
        display: flex;
        align-items: center;
        background: #e4e4e4;
        padding: 0 6px;
        border-radius: 4px;
        > div {
          > img {
            width: 66px;
            height: 66px;
            border-radius: 3px;
            display: block;
          }
        }
        > i {
          font-size: 16px;
          color: #bbbbbb;
          border-radius: 50%;
          background: #fff;
          position: absolute;
          top: -6px;
          right: -6px;
          cursor: pointer;
        }
      }
      > .mr-0 {
        margin-right: 0 !important;
      }
    }
  }
  /deep/ .el-button {
    width: 332px;
    height: 30px;
    background: #ffffff;
    border-radius: 2px;
    border: 1px solid #2154f4;
    color: #2154f4;
    font-size: 12px;
    padding: 0;
    margin-top: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/myviews/shoppMall/activityPageSet/fullPlatformSetQuery/lowCode/custom-component/productComponents/AssemblyGoods/components/GoodsControl.vue